import { useEffect, useRef, useState } from "react";
import { Reveal } from "../lib/motion";
import { KONFIGURATOR_URL } from "../lib/data";
import { Settings2, ExternalLink } from "lucide-react";

const KONFIGURATOR_ORIGIN = new URL(KONFIGURATOR_URL).origin;

export const Konfigurator = () => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    const onMessage = (e) => {
      if (
        e.origin !== KONFIGURATOR_ORIGIN ||
        e.source !== iframeRef.current?.contentWindow ||
        e.data?.type !== "resize" ||
        !Number.isFinite(e.data.height) ||
        e.data.height <= 0
      ) return;

      setHeight(Math.ceil(e.data.height));
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <section id="konfigurator" data-testid="konfigurator-section" className="relative py-28 md:py-36 bg-brand-surface border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-4 flex items-center gap-3">
              <Settings2 size={14} /> Konfigurator
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight text-white">
              Finde dein Fahrzeug
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/60 max-w-md leading-relaxed">
              Wähle Marke, Modell und Motorisierung und sieh sofort, welche Optimierungen für
              dein Fahrzeug möglich sind.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative border border-slate-800 bg-brand-dark shadow-[0_0_50px_rgba(0,85,255,0.08)]">
            <div className="flex items-center justify-between gap-3 px-4 sm:px-5 py-3 border-b border-slate-800 bg-brand-elevated">
              <div className="flex shrink-0 items-center gap-2" aria-hidden="true">
                <span className="w-3 h-3 rounded-full bg-slate-600" />
                <span className="w-3 h-3 rounded-full bg-slate-600" />
                <span className="w-3 h-3 rounded-full bg-brand" />
              </div>
              <span className="min-w-0 truncate font-mono text-[10px] uppercase tracking-widest text-white/60">Fahrzeug-Konfigurator</span>
              <a href={KONFIGURATOR_URL} target="_blank" rel="noreferrer"
                 data-testid="konfigurator-open-btn"
                 aria-label="Konfigurator in einem neuen Tab öffnen"
                 className="flex h-9 w-9 shrink-0 items-center justify-center text-white/60 hover:text-brand-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-light transition-colors"><ExternalLink size={15} /></a>
            </div>
            <div className="w-full overflow-auto">
              <iframe
                ref={iframeRef}
                id="fahrzeug-konfigurator"
                data-testid="konfigurator-iframe"
                src={KONFIGURATOR_URL}
                title="ECU Solutions Fahrzeug-Konfigurator"
                scrolling={height ? "no" : "auto"}
                loading="lazy"
                className="h-[620px] sm:h-[460px] lg:h-[360px]"
                style={{
                  width: "100%",
                  border: "none",
                  display: "block",
                  ...(height ? { height: `${height}px` } : {}),
                }}
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
